import { rootResourceStore } from '.';
import { warnAndNotify } from '../Honeybadger';
import { MissingLinkError } from '../LinkyLinky';

export const reportMissingRootsLink = (error: MissingLinkError): void =>
  warnAndNotify('MissingLinkError', `Client application did not receive link: ${error.rel}`, {
    state: rootResourceStore.state,
  });
